import styled from 'styled-components'
import { COLORS } from 'consts/colors'

export const MagnetizingLine = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 1px;
  background-color: ${COLORS.textPrimary};
  z-index: 1000;
  pointer-events: none;
  opacity: 0.8;
  box-shadow: 0 0 4px rgba(20, 20, 43, 0.5);
  display: none;

  animation: magnetizingPulse 0.1s ease-in-out;

  @keyframes magnetizingPulse {
    0% {
      opacity: 0;
      transform: scaleX(0.5);
    }
    100% {
      opacity: 0.8;
      transform: scaleX(1);
    }
  }
`
